export default "__VITE_ASSET__CdLLVJ8E__"